import React from "react";

import "./tabelaRelatorioTipo.css";
import { useTiposChamado } from '../../../hooks/useTiposChamado';

function TabelaRelatorioTipo(props) {

    const { getNome } = useTiposChamado();
    const colunasStatus = props.colunasStatus || [];
    const lista = props.arrayRelatorioGeral || [];

    const toKey = (cod) => 'S_' + String(cod ?? '').replace(/\W/g, '_');
    const totais = { fechadas: 0 };
    colunasStatus.forEach((st) => { totais[toKey(st.codigo_legado)] = 0; });
    lista.forEach((rel) => {
        totais.fechadas += rel.fechadas ?? 0;
        colunasStatus.forEach((st) => {
            const k = toKey(st.codigo_legado);
            totais[k] = (totais[k] || 0) + (rel[k] ?? 0);
        });
    });

    return (
        <table className="table table-modern align-middle">
            <thead>
                <tr>
                    <th scope="col">Tipo</th>
                    {colunasStatus.map((st) => (
                        <th key={st.codigo_legado} scope="col">{st.nome || st.codigo_legado}</th>
                    ))}
                    <th scope="col">Concluída</th>
                </tr>
            </thead>
            <tbody>
                {lista.map((rel) => (
                    <tr key={rel.id}>
                        <td className="texto-pequeno">{rel.tipo_nome ?? getNome(rel.tipo) ?? '—'}</td>
                        {colunasStatus.map((st) => {
                            const val = rel[toKey(st.codigo_legado)] ?? 0;
                            return <td key={st.codigo_legado} className="texto-pequeno">{val === 0 ? '-' : val}</td>;
                        })}
                        <td className="texto-pequeno">{(rel.fechadas ?? 0) === 0 ? '-' : rel.fechadas}</td>
                    </tr>
                ))}
                <tr className="table-modern-total">
                    <td className="texto-pequeno">TOTAL</td>
                    {colunasStatus.map((st) => {
                        const val = totais[toKey(st.codigo_legado)] ?? 0;
                        return <td key={st.codigo_legado} className="texto-pequeno">{val === 0 ? '-' : val}</td>;
                    })}
                    <td className="texto-pequeno">{totais.fechadas === 0 ? '-' : totais.fechadas}</td>
                </tr>
            </tbody>
        </table>
    );
}

export default TabelaRelatorioTipo;
